export const API_ENDPOINT = process.env.RAZZLE_PRISMIC_ENDPOINT;
export const API_CLIENT_CONFIG = {
  accessToken: process.env.RAZZLE_PRISMIC_ACCESSTOKEN,
};
